export interface UserNotificationPreferenceModel {
  userId?: string;
  channelSetting: Channel;
  taskSettings: MaintenanceTask[];
  accountSettings: AccountReminder[];
  projectTaskSettings: ProjectTask[];
}

export interface Channel {
  email: boolean;
  emailFrequencyId: number;
}

export interface MaintenanceTask {
  notificationCategoryId: number;
  email: boolean;
}

export interface AccountReminder {
  notificationCategoryId: number;
  email: boolean;
  notifyDays: number;
}

export interface ProjectTask {
  notificationCategoryId: number;
  email: boolean;
}

export enum NotificationCategory {
  Task = 1,
  TaskNote = 2,
  TaskMedia = 3,
  TaskReminder = 4,
  AccountReminder = 5,
  Project = 6,
  ProjectTask = 7
}

export enum ChannelEmailFrequency {
  Individual = 1,
  WeeklyDigest = 2,
  MonthlyDigest = 3,
}